import { render, staticRenderFns } from "./PColapsable.vue?vue&type=template&id=78b21b69&scoped=true"
import script from "./PColapsable.vue?vue&type=script&lang=ts"
export * from "./PColapsable.vue?vue&type=script&lang=ts"
import style0 from "./PColapsable.vue?vue&type=style&index=0&id=78b21b69&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78b21b69",
  null
  
)

export default component.exports